import { __decorate, __metadata } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
let SelectedRangeModelImpl = class SelectedRangeModelImpl {
    constructor() { }
};
SelectedRangeModelImpl = __decorate([
    injectable()
    // @ts-ignore
    ,
    __metadata("design:paramtypes", [])
], SelectedRangeModelImpl);
export { SelectedRangeModelImpl };
